// users reducer
export default function vendors(state = {}, action) {
  switch (action.type) {
    case 'user_list_SUCCESS':
      return { ...state, data: action.payload.data, error: null }
    case 'user_list_FAIL':
      return { ...state, error: action.payload.error.reponse.data }

    case 'user_update':
      var user = action.payload.request.data;
      var i = state.data.findIndex(e => e._id == user._id);
      if (i >= 0) {
        state.data[i] = Object.assign({}, state.data[i], user);
      }
      return {
        ...state,
        data: [].concat(state.data)
      };
    case 'user_update_SUCCESS':
      return {
        ...state
      }
    case 'user_update_FAIL':
      return { ...state, error: action.payload.error.reponse.data }

    // initial state
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./client/reducers/users.js